import { StandaloneImage } from '@/components/Image';
import { theme } from '@/hant/tailwind';
import { LabradorComponent } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';

export const HantStandaloneImage: typeof StandaloneImage = ({ options, ...props }) => {
  const maxContentWidth = theme.extend.maxWidth.tabloid;
  const sizes = `(max-width: ${maxContentWidth}) 100vw, ${maxContentWidth}`;

  return <StandaloneImage options={{ ...options, sizes, maxWidth: 980 }} {...props} />;
};

export const standalone = HantStandaloneImage;

const HantLabradorImage: LabradorComponent = ({ type, data, meta, descendants }) => (
  <StandaloneImage
    src={data.src}
    alt={data.alt}
    caption={data.showCaption && data.caption}
    byline={data.showCaption && data.byline}
    {...withDebugMetadata({ type, meta })}
  />
);

export default HantLabradorImage;
